import React from 'react';

const Home = () => (
  <main>
    <h2>Dashboard</h2>
  </main>
);

export default Home;
